import { sendGAWabunkaSectionViewAllEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/sectionViewAll';

/**
 * Top ページ Theme セクションの「View all experiences」クリック時に
 * 体験一覧ページ (/s/experiences/) へ遷移する処理を提供する。
 */
export const useTopThemeActions = () => {
  const route = useRoute();

  const onClickThemeViewAll = () => {
    sendGAWabunkaSectionViewAllEvent('featured-theme', route.name as string);
    navigateTo('/s/experiences/');
  };

  return { onClickThemeViewAll };
};
